const config = {
  logLevel: 'debug' 
  
};
  
  export default config;